import { useQueryClient } from '@tanstack/react-query'
import { useEffect } from 'react'

import { CommonService } from '@/services/common.service'

import { useAuth } from '@/auth/useAuth'
import { PLATFORM_API_MAP } from '@/constants/common'

const TAGS_PREFETCH_CACHE_TTL = 1000 * 60 * 60

export const usePrefetchTags = () => {
	const queryClient = useQueryClient()
	const { isInt } = useAuth()

	useEffect(() => {
		const tagsConfigs = Object.values(PLATFORM_API_MAP).filter(({ source }) => {
			if (isInt) return source === 'viory'

			return true
		})

		tagsConfigs.forEach(({ source, lang }) => {
			queryClient.prefetchQuery({
				queryKey: ['tags', source, lang],
				queryFn: () => CommonService.getTags(source, lang),
				staleTime: TAGS_PREFETCH_CACHE_TTL,
				cacheTime: TAGS_PREFETCH_CACHE_TTL
			})
		})
	}, [queryClient, isInt])
}
